import { render, staticRenderFns } from "./JigWarningModals.vue?vue&type=template&id=04ad61b8"
import script from "./JigWarningModals.vue?vue&type=script&lang=ts"
export * from "./JigWarningModals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports